import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { WORKFLOWS } from '../../../Workflows/WorkflowMapping'
import { useZocksAuth, useZocksQuota } from '../../../../components/ScopedBlock/hooks'
import { useGetAllEnabledWorkflowsQuery } from '../../../../store/workflow/enabledWorkflows'
import { parseMetadata } from '../../../../common/util'
import { RoomSession } from '../../../../models/Room'

export const useAutoMeetingPrep = () => {
  const accountId = useAppSelector(selectAccountId)

  const { hasScope } = useZocksAuth()
  const { hasQuota } = useZocksQuota()

  const autoMeetingPrepQuotaEnabled = hasQuota('workflow.autoMeetingPrep.value')
  const hasWorkflowUpdateScope = hasScope('**', 'enabled_workflow:update', ['enabled_workflow:admin'])
  const { data: enabledWorkflows, isLoading: autoMeetingPrepLoading, isFetching: autoMeetingPrepFetching } = useGetAllEnabledWorkflowsQuery({ accountId })

  const autoMeetingPrepWorkflow = enabledWorkflows?.data.find((enabledWorkflow) => enabledWorkflow.workflowId === WORKFLOWS.meetingPrep.id) ?? null

  return { autoMeetingPrepQuotaEnabled, hasWorkflowUpdateScope, autoMeetingPrepWorkflow, autoMeetingPrepLoading, autoMeetingPrepFetching }
}

export const useAutoMeetingPrepMetadata = (roomSession: RoomSession | null) => {
  if (!roomSession) {
    return { startedAt: null, finishedAt: null }
  }

  const externalMetadata = parseMetadata(roomSession.metadata).external ?? {}
  const startedAt = externalMetadata.autoMeetingPrep?.startedAt ?? null
  const finishedAt = externalMetadata.autoMeetingPrep?.finishedAt ?? null

  return { startedAt, finishedAt }
}
